<template>
  <div>
    <div class="containerFull" style="min-height:600px">
      <div class="p-grid">
        <div class="p-col-12">
          <h2 style="border-bottom: 1px solid #cfcfcf;" class="p-pb-5 p-mt-6 titulo-admin p-ml-2">
            Listado de Pólizas
          </h2>
          <DataTable
            ref="dt"
            :value="itemsList"
            dataKey="id"
            :paginator="true"
            :rows="10"
            :filters="filters"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 25]"
            currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} pólizas"
            class="p-datatable-responsive-demo p-mt-5"
            style="margin-bottom:100px"
            :loading="loading"
          >
            <template #header>
              <div
                class="table-header"
                style="align-items: center;display: flex;"
              >
                <Button
                  icon="pi pi-plus"
                  class="p-button-rounded p-button-info p-mr-3"
                  @click="openNew"
                  :disabled="loading"
                  v-tooltip.rigth="'Agregar nuevo'"
                  name="nuevo"
                />
                <span class="p-input-icon-left" style="margin-left: auto;">
                  <i class="pi pi-search" />
                  <InputText
                    v-model="filters['global']"
                    placeholder="Buscar..."
                  />
                </span>
              </div>
            </template>
            <Column field="nombre" header="Nombre" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Nombre</span>
                {{ slotProps.data.nombre }}
              </template>
            </Column>
            <Column field="codigo" header="Código" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Código</span>
                {{ slotProps.data.codigo }}
              </template>
            </Column>
            <Column field="valor" header="Valor (COP)" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Valor (COP)</span>
                {{ formatNumber(slotProps.data.valor) }}
              </template>
            </Column>
            <Column field="observacion" header="Observación" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Observación</span>
                {{ slotProps.data.observacion }}
              </template>
            </Column>
            <Column field="activa" header="Activa" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Activa</span>
                {{ slotProps.data.activa == 0 ? "No" : "Si" }}
              </template>
            </Column>
            <Column :exportable="false">
              <template #body="slotProps">
                <span class="p-column-title">Acciones</span>
                <Button
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success p-mr-2"
                  @click="editItem(slotProps.data)"
                  v-tooltip.top="'Editar'"
                  name="editar"
                />
                <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning"
                  @click="confirmDeleteItem(slotProps.data)"
                  v-tooltip.top="'Eliminar'"
                  name="eliminar"
                />
              </template>
            </Column>
          </DataTable>
          <Dialog
            :closable="false"
            :visible="itemDialog"
            :style="{ width: '450px' }"
            header="Detalles de la Póliza"
            :modal="true"
            class="p-fluid"
            :contentStyle="{ overflow: 'visible' }"
          >
            <div class="p-grid">
              <div class="p-field p-col-12">
                <label for="nombre">Nombre</label>
                <InputText
                  id="nombre"
                  v-model.trim="item.nombre"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !item.nombre }"
                />
                <small class="p-invalid" v-if="submitted && !item.nombre"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-12">
                <label for="codigo">Código</label>
                <InputText
                  id="codigo"
                  v-model.trim="item.codigo"
                  required="true"
                  autofocus
                  :class="{
                    'p-invalid': submitted && !item.codigo,
                  }"
                />
                <small class="p-invalid" v-if="submitted && !item.codigo"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-12">
                <label for="valor">Valor (COP)</label>
                <InputText
                  id="valor"
                  v-model.trim="item.valor"
                  required="true"
                  autofocus
                  type="number"
                  :class="{
                    'p-invalid': submitted && !item.valor,
                  }"
                />
                <small class="p-invalid" v-if="submitted && !item.valor"
                  >El campo es requerido</small
                >
              </div>              
              <div class="p-field p-col-12">
                <label for="activa">Estado</label>
                <div
                  v-for="(tipo_actividad, index) in tipos_estado"
                  :key="index"
                  class="p-field-radiobutton"
                >
                  <RadioButton
                    :id="index"
                    name="activa"
                    :value="tipo_actividad.value"
                    v-model="item.activa"
                    autofocus
                  />
                  <label :for="index">{{ tipo_actividad.name }}</label>
                </div>
              </div>
              <div class="p-field p-col-12">
                <label for="observacion">Observación</label>
                <InputText
                  id="observacion"
                  v-model.trim="item.observacion"
                  autofocus
                />
              </div>
            </div>
            <template #footer>
              <Button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                @click="hideDialog"
                name="cancelar"
              />
              <Button
                label="Guardar"
                icon="pi pi-check"
                class="p-button-text"
                @click="saveItem"
                :disabled="loading"
                name="guardar"
              />
            </template>
          </Dialog>
          <Dialog
            :visible="deleteItemDialog"
            :style="{ width: '450px' }"
            header="Confirmación de eliminación"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="item"
                >Esta seguro que desea eliminar la póliza
                <b>{{ item.nombre }}</b
                >?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteItemDialog = false"
                name="cancelar"
              />
              <Button
                label="Si"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteItemSelected"
                name="aceptar"
              />
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PolizasService from "../service/polizas.service";
export default {
  metaInfo: {
    title: 'Backoffice - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Backoffice - QualityCare',
        content: 'Administración del sitio web',
      },
    ],
  },
  data() {
    return {
      polizasService: null,
      filters: {},
      item: {},
      itemsList: [],
      itemDialog: false,
      deleteItemDialog: false,
      submitted: false,
      loading: false,
      tipos_estado: [
        { name: "Inactiva", value: 0 },
        { name: "Activa", value: 1 },
      ],
    };
  },
  created() {
    this.polizasService = new PolizasService();
  },
  mounted() {
    this.recuperarItemsForList();
  },
  methods: {
    recuperarItemsForList() {
      this.loading = true;
      this.polizasService
        .allPolizasforadmin()
        .then((result) => {
          if (result.data.data) {
            this.itemsList = [...result.data.data];
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al cargar las pólizas",
            life: 3000,
          });
          this.loading = false;
        });
    },
    openNew() {
      this.item = { activa: 1 };
      this.submitted = false;
      this.itemDialog = true;
    },
    hideDialog() {
      this.itemDialog = false;
      this.submitted = false;
    },
    async saveItem() {
      this.submitted = true;
      if (this.item.nombre && this.item.codigo && this.item.valor) {
        this.loading = true;
        if (this.item.id) {
          //edicion de item
          let idItemEnEdicion = this.item.id;
          let itemEditado = {};
          await this.polizasService
            .editarPoliza(this.item)
            .then((result) => {
              if (result.data.data) {
                itemEditado = result.data.data;
                this.$set(
                  this.itemsList,
                  this.findIndexById(idItemEnEdicion),
                  itemEditado
                );
                this.$toast.add({
                  severity: "success",
                  summary: "Felicidades",
                  detail: "Item actualizado",
                  life: 3000,
                });
                this.item = {};
                this.itemDialog = false;
                this.loading = false;
              } else {
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: "Error al guardar",
                  life: 3000,
                });
                this.loading = false;
              }
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        } else {
          //nuevo item
          await this.polizasService
            .crearPoliza(this.item)
            .then((result) => {
              if (result.data.data) {
                this.itemsList.push(result.data.data);
                this.$toast.add({
                  severity: "success",
                  summary: "Felicidades",
                  detail: "Item creada",
                  life: 3000,
                });
                this.item = {};
                this.itemDialog = false;
                this.loading = false;
              } else {
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: "Error al guardar",
                  life: 3000,
                });
                this.loading = false;
              }
            })
            .catch((err) => {
              this.loading = false;
              console.log(err);
            });
        }
      }
    },
    editItem(item) {
      this.item = { ...item };
      this.itemDialog = true;
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.itemsList.length; i++) {
        if (this.itemsList[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    confirmDeleteItem(item) {
      this.item = item;
      this.deleteItemDialog = true;
    },
    deleteItemSelected() {
      this.polizasService
        .eliminarPoliza({ id: this.item.id })
        .then(() => {
          this.itemsList = this.itemsList.filter(
            (val) => val.id !== this.item.id
          );
          this.deleteItemDialog = false;
          this.item = {};
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: "Item eliminado",
            life: 3000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatNumber(numero) {
      return new Intl.NumberFormat("de-DE").format(numero);
    },
  },
};
</script>

<style lang="scss" scoped>
.tituloUsuarios {
  font-size: 28px;
  font-weight: 400;
  margin-right: 50px;
}
.muyLargo {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}

.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 40em) {
  /deep/ .p-datatable {
    &.p-datatable-responsive-demo {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }

        &:last-child {
          border-bottom: 1px solid var(--surface-d);
        }
      }
    }
  }
}
</style>
